// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"ef1dd0d0","675":"e0839fed","875":"5e7393e8","938":"ca03f710","941":"f818e786"}[chunkId] + ".chunk.css";
};